/**
 * PostHog survey IDs used throughout the app.
 * Each survey is created in the PostHog dashboard (or via API) and referenced here by ID.
 * Override any ID via the corresponding VITE_ environment variable.
 */

export const POSTHOG_SIGNUP_ROLE_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_SIGNUP_ROLE_SURVEY_ID ||
  '019c90d8-a714-0000-ce7a-99b3db33f780';

export const POSTHOG_SLACK_COMMUNITY_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_SLACK_COMMUNITY_SURVEY_ID ||
  '019d64d1-ce1c-0000-db92-15a16d77733f';

export const POSTHOG_SLACK_CHANNEL_POPUP_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_SLACK_CHANNEL_POPUP_SURVEY_ID ||
  '019e8f48-2764-0000-6de8-a510fc2ebdcb';

export const POSTHOG_DOMAIN_CHANGE_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_DOMAIN_CHANGE_SURVEY_ID ||
  '019e2932-c241-0000-ea1f-04c9eeece275';
